import React from 'react';
import './Icon.css';

export default () => (
  <div className="LoadingIcon">
    <div className="ball" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Loading.js